import React from "react";
import { FormBlockType } from "modules/forms/hooks/usefetchForm";
import BlockWrapper from "modules/forms/embedded/blocks/BlockWrapper";

export type SpacingBlockType = Omit<FormBlockType, "data"> & {
    data: {
        space: "small" | "medium" | "large";
    },
}

export default function SpacingBlock(block: SpacingBlockType) {

    return (
        <BlockWrapper name={block.name} hidden={false}>
            <div/>
        </BlockWrapper>
    );
}
